import { moduleRouteDictionaryFactory } from '@tundr/routing';

/**
 * Modulo annullamenti: path sotto /app senza prefisso billing (lista /app/reversals/list).
 */
export const reversalRoutesDictionary = moduleRouteDictionaryFactory(
  'reversal',
  'reversals',
  {
    list: 'list',
    detail: ':orderId/:reversalId',
  },
);
